__turbopack_context__.v({
  "draggableDocumentItem__container": "DraggableDocumentItem-module__sUKBNW__draggableDocumentItem__container",
  "draggableDocumentItem__containerItem": "DraggableDocumentItem-module__sUKBNW__draggableDocumentItem__containerItem",
  "fileWrapper": "DraggableDocumentItem-module__sUKBNW__fileWrapper",
});
